import {useEffect} from 'react';

import {removeAllSuccessNotifications, setShowSuccessNotifications} from '../state/ducks/global';
import {dispatch} from '../state/store';

const useSuccessNotificationsRemover = (isActive = true) => {
    useEffect(() => {
        if (isActive) {
            dispatch(removeAllSuccessNotifications());

            dispatch(setShowSuccessNotifications(false));
        } else {
            dispatch(setShowSuccessNotifications(true));
        }
    }, [isActive]);

    useEffect(() => {
        return () => {
            dispatch(setShowSuccessNotifications(true));
        };
    }, []);
};

export default useSuccessNotificationsRemover;
